import { useContext, useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

import { Datepicker, Form, Select, Text } from '../../../Components/Form';
import FileUploader from '../../../Components/Form/FileUpload';
// import { SportRuleContext } from "../Context/SportRuleContext";
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { getPhotoId, serverErrorHandler } from '../../../Utils/Helpers';
import { SportRuleContext } from '../Context/SportRuleContext';
import { getRanks } from '../Utils/Helpers';

const validationSchema = Yup.object({
  competition_name: Yup.string()
    .required('نام مسابقه الزامی است')
    .max(190, 'نام مسابقه نمی تواند بیشتر از 190 کاراکتر باشد'),
  sport: Yup.string().required('وارد کردن رشته الزامی است'),
  weight: Yup.string().nullable(),
  file: Yup.array()
    .typeError('انتخاب تصویر حکم قهرمانی الزامی است')
    .required('انتخاب تصویر حکم قهرمانی الزامی است'),
  number: Yup.string().required('شماره الزامی است'),
  date: Yup.string().required('تاریخ الزامی است'),
  rank: Yup.number()
    .typeError('انتخاب مقام الزامی است')
    .required('انتخاب مقام الزامی است'),
  province_id: Yup.number()
    .typeError('انتخاب استان الزامی است')
    .required('انتخاب استان الزامی است'),
});

const Create = () => {
  const context = useContext(SportRuleContext);
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const { post, get } = useApi();
  const { error, success } = useToast();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // getSports();
    // getWeights();
    const getData = async () => {
      await getProvinces();
    };
    getData();
  }, []);

  const getProvinces = async () => {
    setLoading(true);
    await get(
      '/province',
      (res) => {
        context.provinces = res.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات ناموفق بود');
        setLoading(false);
      },
    );
  };
  // const getSports = async () => {
  //   get(
  //     "/sport?all=true",
  //     (res) => {
  //       context.sports = res.data;
  //     },
  //     (err) => {
  //       setLoading(false);
  //       error("دریافت اطلاعات با خطا مواجه شد");
  //     },
  //   );
  // };
  // const getWeights = async () => {
  //   get(
  //     "/weight?all=true",
  //     (res) => {
  //       context.weights = res.data;
  //       setLoading(false);
  //     },
  //     (err) => {
  //       setLoading(false);
  //       error("دریافت اطلاعات با خطا مواجه شد");
  //     },
  //   );
  // };

  const submitForm = async (values, setSubmitingForm) => {
    setFormSubmitLoaing(true);
    values['file_id'] = getPhotoId(values['file'], false);
    await post(
      '/sport-rule',
      values,
      (res) => {
        success(`حکم قهرمانی "${values?.competition_name}" باموفقیت ایجاد شد.`);
        setFormSubmitLoaing(false);
        navigate('/sport-rule');
      },
      (err) => {
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error(`حکم "${values?.competition_name}" به علت خطا ایجاد نشد.`);
        }
        setFormSubmitLoaing(false);
      },
    );
  };
  return loading ? (
    <Loading />
  ) : (
    <Master>
      <TitleBar
        title='ایجاد حکم قهرمانی کشور'
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/sport'
      />
      <Form
        initialValues={{
          competition_name: '',
          sport: '',
          weight: '',
          file: '',
          number: '',
          date: '',
          rank: '',
          province_id: '',
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12 col-md-8'>
            <div className='row'>
              <div className='col-12'>
                <Text
                  title='نام مسابقه'
                  name='competition_name'
                  serverError={serverErrors?.competition_name}
                />
              </div>
              <div className='col-12'>
                <Text
                  title='شماره'
                  name='number'
                  serverError={serverErrors?.number}
                />
              </div>
              <div className='col-12'>
                <Datepicker
                  title='تاریخ'
                  name='date'
                  minDate={new Date('1830/01/01')}
                  serverError={serverErrors.date}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-4'>
            <div className='col-12'>
              <Text
                title='رشته'
                name='sport'
                serverError={serverErrors?.sport}
              />
            </div>
            <div className='col-12'>
              <Text
                title='وزن'
                name='weight'
                serverError={serverErrors?.weight}
              />
            </div>
            <div className='col-12'>
              <Select
                name='rank'
                serverError={serverErrors?.rank}
                title='مقام'
                options={getRanks()}
              />
            </div>
            <div className='col-12'>
              <Select
                options={context?.provinces}
                title='استان'
                name='province_id'
                serverError={serverErrors?.province_id}
                optionLabel='name'
                optionValue='id'
              />
            </div>
            <div className='col-12'>
              <FileUploader
                method='post'
                name='file'
                title='تصویر حکم قهرمانی'
                maxFileSize='512KB'
                allowMultiple={false}
                roles={['image/jpg', 'image/jpeg', 'image/png']}
                serverUrl='/file?location=sport_rules&public=0'
                maxFiles={1}
                serverError={serverErrors.file}
              />
            </div>
          </div>
        </div>
      </Form>
    </Master>
  );
};

export default Create;
